(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-gallery"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.card-gallery__texture-video').forEach(function(video) {
      var gallery = video.closest('.card-gallery');
      if (!gallery) return;
      gallery.addEventListener('pointerenter', function() {
        video.play();
      });
      gallery.addEventListener('pointerleave', function() {
        video.pause();
        video.currentTime = 0;
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
